import { render, staticRenderFns } from "./input.component.vue?vue&type=template&id=656faefc&scoped=true&"
import script from "./input.component.vue?vue&type=script&lang=ts&"
export * from "./input.component.vue?vue&type=script&lang=ts&"
import style0 from "./input.component.vue?vue&type=style&index=0&id=656faefc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656faefc",
  null
  
)

export default component.exports